import { makeStyles } from '@material-ui/styles';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
});

const ShopDishesRow = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <span>{t('multiplierMatrix.shopDishes')}</span>
      <InfoIconTooltip title={t('multiplierMatrix.shopDishes.tooltip')} />
    </div>
  );
};

export default ShopDishesRow;
